import React, { useEffect, useRef, useState } from "react";

const interactiveSelector = [
  "a",
  "button",
  "input",
  "textarea",
  "select",
  "[role='button']",
  ".cursor-pointer",
].join(",");

const CustomCursor = () => {
  const cursorRef = useRef(null);
  const dotRef = useRef(null);
  const frameRef = useRef(null);
  const mouseRef = useRef({ x: 0, y: 0 });
  const cursorPositionRef = useRef({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [isInteractive, setIsInteractive] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) {
      return undefined;
    }

    document.body.classList.add("has-custom-cursor");

    const updateCursor = () => {
      const cursor = cursorRef.current;
      const dot = dotRef.current;

      if (cursor && dot) {
        cursorPositionRef.current.x +=
          (mouseRef.current.x - cursorPositionRef.current.x) * 0.18;
        cursorPositionRef.current.y +=
          (mouseRef.current.y - cursorPositionRef.current.y) * 0.18;

        cursor.style.transform = `translate3d(${cursorPositionRef.current.x}px, ${cursorPositionRef.current.y}px, 0)`;
        dot.style.transform = `translate3d(${mouseRef.current.x}px, ${mouseRef.current.y}px, 0)`;
      }

      frameRef.current = window.requestAnimationFrame(updateCursor);
    };

    const handleMouseMove = (event) => {
      mouseRef.current = { x: event.clientX, y: event.clientY };
      setIsVisible(true);
      setIsInteractive(Boolean(event.target.closest(interactiveSelector)));
    };

    const handleMouseLeave = () => setIsVisible(false);
    const handleMouseDown = () => document.body.classList.add("custom-cursor-pressed");
    const handleMouseUp = () => document.body.classList.remove("custom-cursor-pressed");

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", handleMouseLeave);
    window.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("mouseup", handleMouseUp);
    frameRef.current = window.requestAnimationFrame(updateCursor);

    return () => {
      document.body.classList.remove("has-custom-cursor", "custom-cursor-pressed");
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("mouseup", handleMouseUp);
      window.cancelAnimationFrame(frameRef.current);
    };
  }, []);

  return (
    <>
      <span
        ref={cursorRef}
        className={`custom-cursor-ring${isVisible ? " is-visible" : ""}${
          isInteractive ? " is-interactive" : ""
        }`}
        aria-hidden="true"
      />
      <span
        ref={dotRef}
        className={`custom-cursor-dot${isVisible ? " is-visible" : ""}${
          isInteractive ? " is-interactive" : ""
        }`}
        aria-hidden="true"
      />
    </>
  );
};

export default CustomCursor;
